import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

    loginForm = new FormGroup({
        username: new FormControl(''),
        password: new FormControl(''),
    });

    isLoading = false;
    error: any;
    serverError = false;
    timeOut = false;

    bgclass = 'imagebg-1';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.bgSwitcher();
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
  });

  }

  bgSwitcher(){
    setInterval(()=>{
      if(this.bgclass === 'imagebg-1'){
        this.bgclass = 'imagebg-2'
      }else{
        this.bgclass = 'imagebg-1'
      }
    }, 3500);
  }

  login(): any{
    if (this.loginForm.invalid){
      this.error = true;
      this.serverError = false;
      this.timeOut = false;
      return this.isLoading = false;
  } else{
          this.isLoading = true;
          this.error = false;
          this.serverError = false;
          this.timeOut = false;
          this.authService.login(this.loginForm.value).subscribe((response)=>{
            // console.log(response);
            if(response.token){
              this.authService.sessionBuilder(response);
            }
          },
          (error) => {
            if(error.status == 401){
              this.serverError = true;
              this.isLoading = false;
            }
            if(error.status == 408){
              this.timeOut = true;
              this.isLoading = false;
            }
          })
  }
  }

}
